import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

interface Props {
  onSuccess: ()=> void
  title: string
}


const DeleteSection = ({onSuccess, title}:Props) => {
    const [section, setSection] = useState<string>(title)
    useEffect(() => {
        setSection(title)
    }, [title])
    const handleSubmit = (event: any) => {
        onSuccess()
    }

    const renderMsgBox = () => {
        return (
    
                    <div className="modal-content">
                        <div className="modal-body text-center">
                            <span className="avatar avatar-xl bg-transparent-danger text-danger mb-3">
                                <i className="ti ti-trash-x fs-36" />
                            </span>
                            <h4 className="mb-1">Confirm Delete</h4>
                            <p className="mb-3">
                                You want to delete section [{section}].
                            </p>
                            <div className="d-flex justify-content-center">
                                <Link
                                    to="#"
                                    className="btn btn-light me-3"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </Link>
                                <Link to="#"
                                    data-bs-dismiss="modal"
                                    className="btn btn-danger"
                                    onClick={handleSubmit}>
                                    Delete
                                </Link>
                            </div>
                        </div>
                    </div>
        )
    }

    return (
      <div className="modal fade" id="delete_section"
        data-bs-backdrop="static"
        data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered modal-md">
          {renderMsgBox()}
        </div>
      </div>
    )
}

export default DeleteSection